<template>
  <div>
    <vs-row>
      <vs-col
        v-if="league && league.main_photo && league.main_photo.public_id"
        vs-w="2"
        vs-sm="12"
      >
        <cld-image :public-id="league.main_photo.public_id">
          <cld-transformation width="150" crop="scale" />
        </cld-image>
      </vs-col>
      <template
        v-if="league && league.main_photo && league.main_photo.public_id"
      >
        <vs-col vs-w="8">
          <vs-col vs-type="flex" vs-w="12">
            <h2 class="center">{{ league && league.name }}</h2>
          </vs-col>
          <vs-col vs-w="12">
            <div v-html="league && league.description" />
          </vs-col>
        </vs-col>
      </template>
      <template v-else>
        <vs-col vs-type="flex" vs-w="12">
          <h2 class="center">
            {{ league && league.name }}
          </h2>
        </vs-col>
        <vs-col style="margin: 10px 0;">
          <div v-html="league && league.description" />
        </vs-col>
      </template>
    </vs-row>
    <vs-row>
      <vs-col vs-w="2" v-if="false">
        <vs-button @click="attemptMediaRelations">Register As Media</vs-button>
        <div>&nbsp;</div>
      </vs-col>
      <vs-col vs-w="2" v-if="league.open_registration">
        <vs-button @click="attemptRegistration">Register Your Team</vs-button>
      </vs-col>
      <vs-col vs-w="2" v-if="league.tip_league">
        <vs-button type="border" @click="attemptTipLeague"
          >Tip the League!</vs-button
        >
      </vs-col>
    </vs-row>
    <vs-divider />
    <vx-card>
      <vs-tabs>
        <vs-tab label="Schedule">
          <div class="tab-text">
            <vs-table :data="games" :noDataText="emptyGameTxt">
              <template slot="thead">
                <vs-th>Date</vs-th>
                <vs-th>Court</vs-th>
                <vs-th>Away Team</vs-th>
                <vs-th>Home Team</vs-th>
                <vs-th>Score</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="tr in data" :key="tr.id">
                  <vs-td
                    :data="tr.game_date && dateFormat(Date.parse(tr.game_date))"
                  >
                    {{ tr.game_date && dateFormat(Date.parse(tr.game_date)) }}
                  </vs-td>
                  <vs-td :data="tr.court_name">
                    {{ tr.court_name }}
                  </vs-td>
                  <vs-td :data="tr.awayteam_name">
                    <router-link
                      :to="{
                        name: 'team',
                        params: { id: tr.awayteam_id }
                      }"
                    >
                      {{ tr.awayteam_name }}
                    </router-link>
                  </vs-td>
                  <vs-td :data="tr.hometeam_name">
                    <router-link
                      :to="{
                        name: 'team',
                        params: { id: tr.hometeam_id }
                      }"
                    >
                      {{ tr.hometeam_name }}
                    </router-link>
                  </vs-td>
                  <vs-td :data="score(tr)">
                    <router-link
                      :to="{ name: 'boxscore', params: { id: tr.game_id } }"
                    >
                      {{ score(tr) }}
                    </router-link>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-tab>
        <vs-tab label="Standings">
          <div class="tab-text">
            <vs-table :data="teamStandings">
              <template slot="thead">
                <vs-th>Team Name</vs-th>
                <vs-th>Record</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="tr in data" :key="tr.id">
                  <vs-td :data="tr.name">
                    <router-link
                      :to="{
                        name: 'team',
                        params: { id: tr.id }
                      }"
                    >
                      {{ tr.name }}
                    </router-link>
                  </vs-td>
                  <vs-td> {{ tr.wins.length }} - {{ tr.losses.length }} </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-tab>
        <vs-tab label="Analytics">
          <div class="tab-text">
            <Analytics :league="league" />
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
    <vs-popup :title="`${league.name} Registration`" :active.sync="addTeamForm">
      <div v-if="league.registration_price">
        <p>
          The fee for this league is
          <b>{{ league.registration_price }} credits</b>.
        </p>
        <p v-if="league.registration_price > accountBalance">
          You must <router-link to="/profile">add more credits</router-link> to
          register a team for this league
        </p>
        <p>
          You have <b>{{ accountBalance }} credits</b>.
        </p>
      </div>
      <div class="my-5">Select one of your available teams below</div>
      <div>
        <vs-select
          class="selectExample"
          label="Available Teams"
          v-model="selectedTeam"
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in availableTeams"
          />
        </vs-select>
      </div>
      <div>
        <vs-textarea
          name="description"
          v-model="description"
          icon-no-border
          icon="icon icon-user"
          icon-pack="feather"
          label="Note to League"
          class="w-full"
        />
      </div>
      <div style="margin: 10px 0 0">
        <vs-button @click="sendTeam()" :disabled="isNotEnoughCredits">
          Register Team
        </vs-button>
      </div>
    </vs-popup>
    <vs-popup :title="`Tip the ${league.name}!`" :active.sync="addTipLeague">
      <h3>Thank You</h3>
      <div>We appreciate your contribution to our league.</div>
      <div>You can leave us a message if you would like</div>
      <div>
        <vs-textarea
          name="description"
          v-model="tipLeagueDescription"
          icon-no-border
          icon="icon icon-user"
          icon-pack="feather"
          label=""
          class="w-full h5"
        />
      </div>
      <div>
        <div>The minimum tip is 1 Ballstar credit.</div>
        <vs-input-number v-model="tipLeagueAmount" min="1" />
      </div>
      <vs-divider />
      <div>
        You have <strong>{{ accountBalance }}</strong> Ballstar credits
        available.
      </div>
      <div v-if="accountBalance >= tipLeagueAmount">
        You are about to tip <strong>{{ tipLeagueAmount }}</strong> of your
        Ballstar credits.
      </div>
      <div v-else style="color:red">
        You dont have enough credits to tip
        <strong>{{ tipLeagueAmount }}</strong
        >.
      </div>
      <div style="margin: 10px 0 0">
        <vs-button
          @click="tipLeague()"
          :disabled="accountBalance < tipLeagueAmount"
        >
          Tip the League!
        </vs-button>
      </div>
    </vs-popup>
    <vs-popup
      :title="`${league.name} Media Relations`"
      :active.sync="addMediaRelations"
    >
      <div>
        <p class="h5">You can register as a photographer or videographer.</p>
        <p class="h5">
          The daily fee for videographers in this league is <b>50 credits</b>.
        </p>
        <p class="h5">
          You also have the option to register for the entire season.
        </p>
        <p class="h5">You have <b>125 credits available</b>.</p>
      </div>
      <vs-divider />
      <div class="my-5">Are you a photographer or videographer?</div>
      <div>
        <ul>
          <li>
            <vs-radio v-model="mediaType" vs-name="Photographer" vs-value="1"
              >Photographer</vs-radio
            >
          </li>
          <li>
            <vs-radio v-model="mediaType" vs-name="Videographer" vs-value="2"
              >Videographer</vs-radio
            >
          </li>
        </ul>
      </div>
      <div v-if="!hidePayOptions">
        <div class="my-5">
          Select the media pass you would like to purchase?
        </div>
        <div>
          <vs-select
            class="selectExample h5"
            label="Media Pass Options"
            v-model="selectedMediaOption"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.name"
              v-for="(item, index) in mediaItems"
            />
          </vs-select>
        </div>
      </div>
      <div>
        <vs-textarea
          name="description"
          v-model="description"
          icon-no-border
          icon="icon icon-user"
          icon-pack="feather"
          label="Additional Information the League should know"
          class="w-full h5"
        />
      </div>
      <div>
        <vs-checkbox
          >Confirm you have read the <a href="">waiver</a>.</vs-checkbox
        >
      </div>
      <div style="margin: 10px 0 0">
        <vs-button @click="sendTeam()" :disabled="isNotEnoughCredits">
          Register as Media
        </vs-button>
      </div>
    </vs-popup>
    <vs-popup title="Login or Create an Account" :active.sync="loginCreateForm">
      <div>
        You must <a href="/login" target="_blank">Login</a> or
        <a href="/register" target="_blank">Create an account</a> to register a
        team in this league.
      </div>
    </vs-popup>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import UserRoles from "@/mixins/UserRoles";
import Analytics from "./Analytics";
const dateTimeFormat = new Intl.DateTimeFormat("en", {
  year: "numeric",
  month: "short",
  day: "2-digit",
  hour: "numeric",
  minute: "numeric"
});
export default {
  name: "League",
  created() {
    this.loadLeagueAndGames();
  },
  components: {
    Analytics
  },
  props: ["id"],
  watch: {
    id() {
      this.loadLeagueAndGames();
    },
    mediaType() {
      console.log(this.mediaType);
      if (parseInt(this.mediaType) === 1) {
        this.hidePayOptions = true;
      } else if (parseInt(this.mediaType) === 2) {
        this.hidePayOptions = false;
      }
    }
  },
  mixins: [UserRoles],
  data() {
    return {
      games: [],
      schedule: [],
      league: {},
      emptyGameTxt: "Searching Ballstar database...",
      addTeamForm: false,
      addMediaRelations: false,
      addTipLeague: false,
      loginCreateForm: false,
      availableTeams: [],
      mediaItems: [
        { id: 1, name: "1 Day Pass ($50)", value: 1 },
        { id: 2, name: "League Pass ($500)", value: 2 }
      ],
      selected: [],
      selectedTeam: null,
      selectedMediaOption: null,
      description: null,
      accountPayments: [],
      mediaType: {},
      hidePayOptions: false,
      tipLeagueAmount: 1,
      tipLeagueDescription: ""
    };
  },
  computed: {
    accountBalance() {
      return (
        this.accountPayments &&
        this.accountPayments.reduce((acc, obj) => {
          acc += obj.credits;
          return acc;
        }, 0)
      );
    },
    isNotEnoughCredits() {
      return (
        this.league.registration_price &&
        this.accountBalance < this.league.registration_price
      );
    },
    leagueName() {
      return this.league && this.league.name;
    },
    leagueDescription() {
      return this.league && this.league.description;
    },
    teamStandings() {
      const standings = {};
      this.games
        .filter(g => g.active)
        .map(g => {
          if (!standings[g.hometeam_id]) {
            standings[g.hometeam_id] = {
              id: g.hometeam_id,
              name: g.hometeam_name,
              wins: [],
              losses: [],
              draws: []
            };
          }

          if (!standings[g.awayteam_id]) {
            standings[g.awayteam_id] = {
              id: g.awayteam_id,
              name: g.awayteam_name,
              wins: [],
              losses: [],
              draws: []
            };
          }

          if (g.away_team_score > g.home_team_score) {
            standings[g.hometeam_id].losses.push({
              team: g.awayteam_id,
              game: g.game_id
            });
            standings[g.awayteam_id].wins.push({
              team: g.hometeam_id,
              game: g.game_id
            });
          } else if (g.away_team_score < g.home_team_score) {
            standings[g.hometeam_id].wins.push({
              team: g.awayteam_id,
              game: g.game_id
            });
            standings[g.awayteam_id].losses.push({
              team: g.hometeam_id,
              game: g.game_id
            });
          } else if (
            g.away_team_score === g.home_team_score &&
            g.away_team_score !== 0 &&
            g.home_team_score !== 0
          ) {
            standings[g.hometeam_id].draws.push({
              team: g.awayteam_id,
              game: g.game_id
            });
            standings[g.awayteam_id].draws.push({
              team: g.hometeam_id,
              game: g.game_id
            });
          }
        });
      return Object.values(standings)
        .filter(
          t =>
            (t.wins.length === 0 && t.losses.length !== 0) ||
            (t.wins.length !== 0 && t.losses.length === 0) ||
            (t.wins.length !== 0 && t.losses.length !== 0)
        )
        .sort((b, a) => a.wins.length - b.wins.length);
    }
  },
  methods: {
    ...mapActions({
      getLeague: "league/getLeague",
      getTeamSeasons: "team/getTeamSeasons",
      getLeagueSchedule: "league/getLeagueSchedule",
      registerTeam: "league/registerTeam",
      myPayments: "payments/myPayments"
    }),
    async loadPayments() {
      const { json } = await this.myPayments();
      this.accountPayments = json;
    },
    async loadLeague() {
      if (this.id) {
        this.league = await this.getLeague({ id: this.id });
      }
    },
    async loadLeagueAndGames() {
      this.$vs.loading();
      await this.loadLeague();
      await this.loadLeagueGames();
      this.$vs.loading.close();
    },
    async loadLeagueTeams() {
      this.$vs.loading();
      const { json } = await this.getTeamSeasons();
      this.availableTeams = json.map(t => ({ ...t, text: t.name, value: t }));
      this.$vs.loading.close();
    },
    dateFormat(d) {
      return dateTimeFormat.format(d);
    },
    async loadLeagueGames() {
      this.emptyGameTxt = "Searching Ballstar database...";
      const { json } = await this.getLeagueSchedule({ id: this.league.id });
      if (!json.length) {
        this.emptyGameTxt = "No Games found";
        this.games = [];
      } else {
        this.games = json
          .filter(a => a.active)
          .sort((b, a) => new Date(a.game_date) - new Date(b.game_date));
      }
    },
    score(gameData) {
      return `${gameData.away_team_score || 0} - ${gameData.home_team_score ||
        0}`;
    },
    async sendTeam() {
      const data = {
        team: this.selectedTeam,
        description: this.description
      };

      try {
        await this.registerTeam({ id: this.league.id, data });
        this.$toasted
          .success("Successfully Sent Team to League for Review")
          .goAway(2000);
      } catch (ex) {
        this.$toasted
          .error(`Already Submitted: ${ex.error || "Unable to Accept Invite"}`)
          .goAway(2000);
      } finally {
        this.addTeamForm = false;
        this.resetTeamInvite();
      }
    },
    resetTeamInvite() {
      this.selectedTeam = null;
      this.description = null;
    },
    createTeamSuccess() {
      this.createTeamForm = false;
    },
    attemptRegistration() {
      if (this.user) {
        this.loadLeagueTeams();
        this.loadPayments();
        this.addTeamForm = true;
      } else {
        this.loginCreateForm = true;
      }
    },
    attemptMediaRelations() {
      if (this.user) {
        this.addMediaRelations = true;
      } else {
        this.loginCreateForm = true;
      }
    },
    attemptTipLeague() {
      if (this.user) {
        this.loadPayments();
        this.addTipLeague = true;
      } else {
        this.loginCreateForm = true;
      }
    }
  },
  metaInfo() {
    return { title: `${this.league.name} - League` };
  }
};
</script>
